<mat-card class="recently-accepted-card" *ngIf="blockData">
    <app-card-header [title]="blockData.blockContent.title" [icon]="blockData.blockContent.icon.content.umbracoFile" /> 
  
    <mat-card-content>
      <app-recently-accepted [data]="blockData"></app-recently-accepted>
    </mat-card-content>
  </mat-card>